import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import { Communicators } from 'presentation/components/lib/communicators';
import Error from 'presentation/components/Error';
import Timestamp from 'presentation/components/Timestamp';

import overrideStyle from 'lib/overrideStyle';
import styles from 'presentation/components/styles/MessageStack.css';
let cx = classnames.bind(styles);

export default function MessageStack(props) {
  let classes = cx('messageStack', {
    messageStack_agent: props.sender === Communicators.AGENT,
    messageStack_customer: props.sender === Communicators.CUSTOMER,
  });

  return (
    <Wrapper className={classes}>
      {props.hasError ? <Error sender={props.sender} /> : null}
      <div className={styles.messageStack_messages}>{props.messages}</div>
      {props.timestamp && <Timestamp sender={props.sender} timestamp={props.timestamp} />}
    </Wrapper>
  );
}

MessageStack.propTypes = {
  hasError: PropTypes.bool,
  messages: PropTypes.array,
  sender: PropTypes.string,
  timestamp: PropTypes.instanceOf(Date),
};

const Wrapper = overrideStyle('div')`
  font-family: ${p => p.theme.fontLibrary.secondary};
  padding-bottom: 5px;
`;
